import * as React from "react";
import '../../App.css';
import './Header.css';
import {Navbar} from "react-bootstrap";
import Logo from "./Logo";
import Navigation from "./Navigation";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSignOutAlt} from "@fortawesome/free-solid-svg-icons";
import {getAuth, signOut} from "firebase/auth";
import {Business, CurrentUser} from "../../types/Types";
import {NavLink, useNavigate} from "react-router-dom";

interface Props {
  currentUser: CurrentUser | undefined,
  businessMap: Map<string, Business> | undefined,
  setCurrentUser: (currentUser: CurrentUser | undefined) => void,
  loading: Boolean,
}

function Header(props: Props) {
  const navigate = useNavigate();

  const logout = () => {
    const auth = getAuth();
    signOut(auth)
      .then(() => {
        window.location.assign("/login");
      });
  };

  return (
      <>
        <Navbar className="ms-2 me-2 navbar navbar-expand-lg navbar-dark bg-blue pb-0 pt-0 pl-2 pr-2">
          <div>
            <Logo />
          </div>
          <div className="ms-auto">
            {props.currentUser && <div className={"header-username"} onClick={() => navigate(`/settings`)}>{props.currentUser.name}</div>}
            {props.currentUser && <div className={"header-buttons"}>
              <div className={"header-button d-inline-block"} onClick={() => logout()}>
                <FontAwesomeIcon icon={faSignOutAlt}/>
              </div>
            </div>}
            {!props.currentUser && <NavLink className="ms-auto nav-link me-0" to="/login">
              <b>Login</b>
            </NavLink>}
          </div>
        </Navbar>
        {(props.currentUser && props.businessMap) && <Navigation currentUser={props.currentUser} business={props.businessMap.get(props.currentUser.business || "")}/>}
        {!props.currentUser && <div className={"mb-3"}></div>}
      </>
  );
}

export default Header;